import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const alertSlice = createApi({
    reducerPath: "alertSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: commonBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAlerts: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/alerts?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Delete Category
        deleteAlert: builder.mutation({
            query: (id) => ({
                url: `/alert/${id}`,
                method: "DELETE",
            }),
        }),

    }),
});

export const {
    useGetAlertsQuery,
    useDeleteAlertMutation,
} = alertSlice;
